<div
  class="h-[48px] w-auto laptop:h-[48px] flex justify-center items-center text-center bg-[#f6f8fc] opacity-100"
>
  <div class="flex justify-around items-center tablet:w-[375px] w-full">
    <div
      class="flex-[0_0_25%] max-w-[25%] border-r border-[#D9D9D9] border-solid h-[20px] flex items-center justify-center"
    >
      <a
        href="{{ content.myTripLink }}"
        (click)="onLinkClick($event)"
        data-acdl-action="skymiles flyout:my trips:link"
        data-acdl-name="my trips"
        data-acdl-page-section="header:skymiles flyout"
        class="font-semibold text-[#0066CC] no-underline text-[14px] leading-[18px]"
      >
        {{ content.myTripLabel }}
      </a>
    </div>
    <div
      class="flex-[0_0_16%] max-w-[16%] border-r border-[#D9D9D9] border-solid h-[20px] flex items-center justify-center"
    >
      <a
        href="{{ content.profileLink }}"
        (click)="onLinkClick($event)"
        data-acdl-action="skymiles flyout:profile:link"
        data-acdl-name="profile"
        data-acdl-page-section="header:skymiles flyout"
        class="font-semibold text-[#0066CC] no-underline text-[14px] leading-[18px]"
      >
        {{ content.profileLabel }}
      </a>
    </div>
    <div
      class="flex-[0_0_33%] max-w-[33%] border-r border-[#D9D9D9] border-solid h-[20px] flex items-center justify-center"
    >
      <a
        href="{{ content.mySkyMilesLink }}"
        (click)="onLinkClick($event)"
        data-acdl-action="skymiles flyout:my skymiles:link"
        data-acdl-name="my skymiles"
        data-acdl-page-section="header:skymiles flyout"
        class="font-semibold text-[#0066CC] no-underline text-[14px] leading-[18px]"
      >
        {{ content.mySkyMilesLabel }}
      </a>
    </div>
    <div
      class="flex-[0_0_25%] max-w-[25%] h-[20px] flex items-center justify-center"
    >
      <a
        (click)="logoutEvent.emit(); onLinkClick($event)"
        href="javascript:void(0);"
        id="flyout-logOut-link"
        role="button"
        data-acdl-action="skymiles flyout:log out:link"
        data-acdl-name="log out"
        data-acdl-page-section="header:skymiles flyout"
        class="font-semibold text-[#0066CC] no-underline text-[14px] leading-[18px]"
      >
        {{ content.LogOutLabel }}
      </a>
    </div>
  </div>
</div>
